import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const Balance = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div class="top-header-sec mb-3">
              <div class="col-12 mt-3">
                <div class="row mx-0 justify-content-between align-items-center">
                  <h4 class="event-alert br-btm-0 col">As of July 21, 2022</h4>
                  <div class="col-md-4 col-2 align-right">
                    <div class="field text-right">
                      <button
                        id="download"
                        class="btn green-btn-revert download-icon mr0"
                      >
                        <i class="i-icon"> </i> Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div class="col-md-12">
                <div class="shadowclass mt-3">
                  <div class="col-12">
                    <div class="select-comparison">
                      <label class="key">Key Statistics Vs.</label>
                      <div class="select-div widthextra">
                        <select
                          name="data[comparison]"
                          class="comparison"
                          id="comparison"
                        >
                          <option value="">Select Comparison</option>
                          <option value="0" selected="selected">
                            Previous Period
                          </option>
                          <option value="1">Same Period Previous Year</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 m-0">
                    <ul class="comparison_listing statistics_balance">
                      <li>
                        <h4>$0 </h4>
                        <p>Balance Sheet Break Amount</p>
                      </li>
                      <li>
                        <h4>0.0</h4>
                        <p>
                          Current Ratio <br />
                          (Cur. Assets / Cur. Liab.)
                        </p>
                      </li>
                      <li>
                        <h4>0.0</h4>
                        <p>
                          Quick Ratio
                          <br /> (Cur. Assets - Inv. / /Cur. Liab.)
                        </p>
                      </li>
                      <li>
                        <h4>0.0</h4>
                        <p>
                          Working Capital Ratio
                          <br />
                          (Total Assets / Total Liab.)
                        </p>
                      </li>
                      <li>
                        <h4>0.0</h4>
                        <p>
                          Debt-to-Equity Ratio
                          <br />
                          (Total Debt / Total Equity)
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0">
              <div className="shadowclass mt-3">
                <div className="container px-0">
                  <div class="row mx-0 justify-content-between">
                    <h4 class="event-alert col-md-5">Balance Sheet</h4>
                    <ul
                      class="nav summary_filter col-md-4"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <a
                          class="nav-link active"
                          id="current-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#current"
                          type="button"
                          role="tab"
                          aria-controls="current"
                          aria-selected="true"
                        >
                          Current
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          class="nav-link"
                          id="former-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#former"
                          type="button"
                          role="tab"
                          aria-controls="former"
                          aria-selected="false"
                        >
                          Former
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="current"
                      role="tabpanel"
                      aria-labelledby="current-tab"
                    >
                      <div class="row mx-0">
                        <div class="col-md-6">
                          <div class="inner-space screen-scroll mCS_destroyed">
                            <table
                              class="checklist-table summary_cost_table mt20"
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <thead>
                                <tr class="border_bottom">
                                  <th>
                                    <strong>Current Assets</strong>
                                  </th>
                                  <th class="align-right">
                                    <strong>$0.00 </strong>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="border_bottom">
                                  <td>
                                    <strong>Fixed Assets</strong>
                                  </td>
                                  <td class="align-right">
                                    <strong>$0.00</strong>
                                  </td>
                                </tr>
                                <tr class="border_Top border_bottom actual_cost_row">
                                  <td class="text-green">
                                    <strong>Total Assets</strong>
                                  </td>
                                  <td class="text-green align-right">
                                    <strong>$0.00</strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="inner-space screen-scroll mCS_destroyed">
                            <table
                              class="checklist-table summary_cost_table mt20"
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <thead>
                                <tr>
                                  <th>
                                    <strong>Liabilities</strong>
                                  </th>
                                  <th>
                                    <strong>$0.00</strong>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="border_bottom">
                                  <td>
                                    <strong>Equity</strong>
                                  </td>
                                  <td class="align-right">
                                    <strong>$0.00</strong>
                                  </td>
                                </tr>

                                <tr class="border_Top border_bottom actual_cost_row">
                                  <td class="text-green">
                                    <strong>
                                      Total Liabilities &amp; Equity
                                    </strong>
                                  </td>
                                  <td class="text-green align-right">
                                    <strong>$0.00</strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="former"
                      role="tabpanel"
                      aria-labelledby="former-tab"
                    >
                      <table className="checklist-table remove-space inventory_table">
                        <tbody>
                          <tr>
                            <td colspan="5">
                              <strong>Attachments </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="qr-list"
                      role="tabpanel"
                      aria-labelledby="qr-list-tab"
                    >
                      <table className="checklist-table remove-space inventory_table">
                        <tbody>
                          <tr>
                            <td colspan="5">
                              <strong>Opposing Entry </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="related-doc"
                      role="tabpanel"
                      aria-labelledby="related-doc-tab"
                    >
                      <table className="checklist-table remove-space inventory_table">
                        <tbody>
                          <tr>
                            <td colspan="5">
                              <strong>RELATED DOCUMENTS </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Balance;
